const hostITD = window.location.host==='itd.local:3011' || window.location.host==='itd.local' ?'itd.local/factura.link/index.php':window.location.host;
const Config = {
    dirroot: window.location.protocol+'//'+hostITD,
    apiGateway: window.location.protocol+'//'+hostITD+'/apiacceso2',
}

export default Config;